/* KICKFIT — strat electric: bară de progres la scroll + scântei la cursor/click */
(function(){
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // bară de progres la scroll
  var bar = document.createElement('div'); bar.id = 'kfeProgress'; bar.setAttribute('aria-hidden','true'); document.body.appendChild(bar);
  var ticking = false;
  function upd(){
    var h = document.documentElement, max = h.scrollHeight - h.clientHeight;
    bar.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, h.scrollTop / max) : 0) + ')';
    ticking = false;
  }
  window.addEventListener('scroll', function(){ if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
  window.addEventListener('resize', upd); upd();

  // scântei — doar pe dispozitive cu mouse
  if (!window.matchMedia || !window.matchMedia('(pointer: fine)').matches) return;
  var COLORS = ['#39FF6A', '#B026FF', '#ffffff'], live = 0, last = 0;
  function spark(x, y, spread){
    if (live > 40) return;
    var s = document.createElement('span'), size = 2 + Math.random() * 4, c = COLORS[Math.floor(Math.random() * COLORS.length)];
    s.className = 'kfe-spark';
    s.style.cssText = 'left:' + x + 'px;top:' + y + 'px;width:' + size + 'px;height:' + size + 'px;background:' + c + ';box-shadow:0 0 8px ' + c + ';' +
      '--dx:' + ((Math.random() - .5) * spread) + 'px;--dy:' + ((Math.random() - .3) * spread) + 'px;';
    live++;
    s.addEventListener('animationend', function(){ s.remove(); live--; });
    document.body.appendChild(s);
  }
  document.addEventListener('mousemove', function(e){
    var t = Date.now(); if (t - last < 55) return; last = t;
    spark(e.clientX, e.clientY, 36);
  }, { passive: true });
  document.addEventListener('click', function(e){
    for (var i = 0; i < 10; i++) spark(e.clientX, e.clientY, 90);
  }, { passive: true });
})();
